import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { ApiResult } from '@/backend/darwin/types'

/** Soft-delete a team on the backend */
export const deleteTeam = async (teamId: number): Promise<ApiResult<void>> => {
  try {
    await api.put<{ success: boolean }>(`teams/${teamId}/archive`)
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.TEAM_DELETE),
      ok: false,
    }
  }

  return {
    data: undefined,
    ok: true,
  }
}
